export const sidebarSmallSizeLogo = 30
export const sidebarMediumSizeLogo = 40
export const mobileToolbarZIndex = 3
export const mobileToolbarButtonsZIndex = mobileToolbarZIndex + 1
export const buildPreviewBannerZIndex = mobileToolbarZIndex - 1

export const mobileFooterNavigationHeight = '4rem'

export const tabBadgeCounterZIndex = mobileToolbarZIndex - 1
